import {
    ARRIVAL_TYPE,
    DEPARTURE_TYPE,
} from '../../../constants';
import * as filterSelectors from '../selectors';
import * as types from '../types';

function _setStationActive(filterId, stationId, direction, isActive) {
    return {
        meta: {
            filterId,
            direction,
            stationId,
        },
        payload: isActive,
        type: types.SET_STATION_ACTIVE,
    };
}

function setStationActive(stationId, isActive, direction, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());

        dispatch(_setStationActive(filterId, stationId, direction, isActive));
    };
}

function setArriveStationActive(stationId, isActive) {
    return setStationActive(stationId, isActive, ARRIVAL_TYPE);
}

function setDepartStationActive(stationId, isActive) {
    return setStationActive(stationId, isActive, DEPARTURE_TYPE);
}

function _setStationOnlyActive(filterId, stationId, direction) {
    return {
        meta: {
            filterId,
            direction,
            stationId,
        },
        type: types.SET_STATION_ONLY_ACTIVE,
    };
}

function setStationOnlyActive(stationId, direction, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());
        dispatch(_setStationOnlyActive(filterId, stationId, direction));
    };
}

function setArriveStationOnlyActive(stationId) {
    return setStationOnlyActive(stationId, ARRIVAL_TYPE);
}

function setDepartStationOnlyActive(stationId) {
    return setStationOnlyActive(stationId, DEPARTURE_TYPE);
}

function resetStations(direction, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());
        return dispatch(_resetStations(filterId, direction));
    };
}

function resetArriveStations() {
    return resetStations(ARRIVAL_TYPE);
}

function resetDepartStations() {
    return resetStations(DEPARTURE_TYPE);
}

function _resetStations(filterId, direction) {
    return {
        meta: {
            filterId,
            direction,
        },
        type: types.RESET_STATIONS,
    };
}

export {
    resetArriveStations,
    resetDepartStations,
    setArriveStationActive,
    setArriveStationOnlyActive,
    setDepartStationActive,
    setDepartStationOnlyActive,
};
